import React from "react";
import WebSVG from "../components/WebSVG";

function SvgView(props) {
  const svgSource = props.source;
  const svgURI = props.uri;
  const onPress = props.onPress;

  return <WebSVG src={svgSource} uri={svgURI} onPress={onPress} />;
}

export default SvgView;
